import { ClipboardList, Landmark, PenTool } from "lucide-react";
import ServizioDetailTemplate from "@/components/servizi/ServizioDetailTemplate";

const SERVIZI = [
  { icon: ClipboardList, titolo: "Redazione di Business Plan completi e strategici", desc: "Analisi dell'idea, del settore, del mercato e delle risorse disponibili; definizione di obiettivi e KPI; elaborazione della strategia di marketing e delle proiezioni finanziarie per la crescita aziendale e l'attrazione di investitori." },
  { icon: Landmark, titolo: "Supporto per convincere gli istituti di credito", desc: "Descrizione chiara del progetto, analisi del mercato di riferimento, piano economico-finanziario con proiezioni realistiche ed evidenza della sostenibilità dell'investimento nel tempo." },
  { icon: PenTool, titolo: "Costruzione della parte analitica e descrittiva", desc: "Un progetto ben descritto ma privo di numeri credibili difficilmente convince un valutatore: costruiamo in modo coerente entrambe le parti per massimizzare il risultato." },
];

export default function BusinessPlanPage() {
  return (
    <ServizioDetailTemplate
      testId="business-plan"
      categoriaLabel="Finanza"
      titolo="Business Plan"
      heroImage="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1400&q=80&auto=format"
      heroImageAlt="Persone al lavoro su documenti e laptop per la redazione di un business plan"
      leadText="Un buon progetto merita un business plan che sappia convincere."
      introText="Trasforma la tua idea in un piano pronto per investitori e banche. Promo.Ter redige per le imprese business plan completi e strategici, capaci di comunicare in modo efficace il valore di un progetto imprenditoriale, offrendo uno strumento utile alla crescita aziendale e all'attrazione di investitori."
      servizi={SERVIZI}
      ctaText="Contatta il nostro ufficio per richiedere la redazione del tuo business plan."
      telefoni={["06.68437.606", "06.68437.530", "06.68437.610"]}
    />
  );
}
